import React, {Component} from "react";

class CodeBlock extends Component {
    render() {
        return (
            <pre className={this.props.className} dangerouslySetInnerHTML={{
                __html: this.props.code.trim()
            }}/>
        )
    }
}

CodeBlock.propTypes = {
    code: React.PropTypes.string.required,
    className: React.PropTypes.string,
};

CodeBlock.defaultProps = {
    className: '',
};

export default CodeBlock;



// WEBPACK FOOTER //
// ./src/modules/common/CodeBlock.js